module.exports = __webpack_public_path__ + "img/training_course_4.ff85e1fa.jpg";